<app-sales-credit-number [creditNumber]="contractNumber" [data]="creditData" *ngIf="categoryCode !== 'kredicash'"></app-sales-credit-number>

<div class="container section__appIntalation h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="small__padBot">
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <ng-container [ngSwitch]="platformType">
          <ng-container *ngSwitchCase="PhonePlatform.Krdya">
            <app-sales-phone-krdya-platform
              [requestId]="requestId"
              (nextStep)="onNextStep()">
            </app-sales-phone-krdya-platform>
          </ng-container>
          <ng-container *ngSwitchCase="PhonePlatform.Knox_krdya">
            <app-sales-phone-knox-krdya-platform
              [requestId]="requestId"
              [otp]="creditData?.agreement?.otp"
              (nextStep)="onNextStep()">
            </app-sales-phone-knox-krdya-platform>
          </ng-container>
          <ng-container *ngSwitchCase="PhonePlatform.Nuovo_krdya">
            <app-sales-phone-nuovo-krdya-platform
              [requestId]="requestId"
              [otp]="creditData?.agreement?.otp"
              (nextStep)="onNextStep()">
            </app-sales-phone-nuovo-krdya-platform>
          </ng-container>

          <ng-container *ngSwitchCase="PhonePlatform.Trustonic">
            <app-sales-phone-trustonic-platform
              [requestId]="requestId"
              [otp]="creditData?.agreement?.otp"
              [contractNumber]="contractNumber"
              [personNumber]="person?.number"
              [trustonicAppUrl]="trustonicAppUrl"
              (nextStep)="onNextStep()">
            </app-sales-phone-trustonic-platform>
          </ng-container>
          <ng-container *ngSwitchCase="PhonePlatform.Trustonic_prepaid">
            <app-sales-phone-trustonic-prepaid-platform
              [requestId]="requestId"
              [otp]="creditData?.agreement?.otp"
              [contractNumber]="contractNumber"
              [personNumber]="person?.number"
              [trustonicAppUrl]="trustonicAppUrl"
              (nextStep)="onNextStep()">
            </app-sales-phone-trustonic-prepaid-platform>
          </ng-container>

          <app-sales-phone-datacultr-platform
            *ngSwitchCase="PhonePlatform.Datacultr"
            [requestId]="requestId"
            [otp]="creditData?.agreement?.otp"
            [contractNumber]="contractNumber"
            [personNumber]="person?.number"
            (nextStep)="onNextStep()">
          </app-sales-phone-datacultr-platform>

          <app-sales-phone-knox-platform
            *ngSwitchCase="PhonePlatform.Knox"
            [requestId]="requestId"
            [contractNumber]="contractNumber"
            [personNumber]="person?.number"
            (nextStep)="onNextStep()">
          </app-sales-phone-knox-platform>

          <app-sales-phone-nuovo-platform
            *ngSwitchCase="PhonePlatform.Nuovo"
            [requestId]="requestId"
            [contractNumber]="contractNumber"
            [personNumber]="person?.number"
            (nextStep)="onNextStep()">
          </app-sales-phone-nuovo-platform>

          <app-sales-phone-absolute-platform
            *ngSwitchCase="PhonePlatform.Absolute"
            (nextStep)="onNextStep()">
          </app-sales-phone-absolute-platform>
        </ng-container>
      </article>
    </div>
  </div>
</div>
